/**
 * Portal API client with X-Portal-Token authentication.
 * Used for patient portal endpoints that require portal session authentication.
 */
import axios from 'axios';
import { portalStorage } from '@/lib/secureStorage';

const API_URL = import.meta.env.VITE_API_URL || '/api';

// Portal uses a separate axios instance with X-Portal-Token header
export const portalClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add portal token
portalClient.interceptors.request.use(
  (config) => {
    const token = portalStorage.getToken();
    if (token) {
      config.headers['X-Portal-Token'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - Handle errors
portalClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      portalStorage.clear();
      window.location.href = '/portal/login';
    }
    return Promise.reject(error);
  }
);

export default portalClient;
